<template>
  <div class="calendar-day-block">
    <div
      v-for="(item, index) in dayLines"
      :key="index"
      class="calendar-day-block-cols"
    >
      <div class="calendar-day-block-tasks">
        <task-block
          :tasks="tasks[index]"
          :isMore="isMore"
          @createTask="createTask($event, index)"
          @resetTask="resetTask($event, index)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import TaskBlock from '../tasks/taskBlock'
import mixin from '@/mixins/calendar'
export default {
  name: 'CalendarDayBlock',
  mixins: [ mixin ],
  components: {
    TaskBlock
  },
  props: {
    tasks: {
      type: Array,
      default () {
        return []
      }
    },
    monday: {
      type: Number
    },
    isMore: {
      type: Boolean
    }
  },
  data () {
    return {
      dayLines: new Array(7),
      curIndex: 0
    }
  },
  methods: {
    // 创建任务
    createTask (params, index) {
      params = this.transformDate(params, this.monday, index)
      this._createTask(params)
    },
    // 修改任务时间
    resetTask (params, index) {
      let _params = this.transformDate(params, this.monday, index)
      let keys = ['id', 'timeType', 'dayType', 'repeatRule']
      keys.map((key) => {
        _params[key] = params[key]
      })
      this._resetTaskTime(_params)
    }
  }
}
</script>
<style lang="stylus">
.calendar-day
  &-block
    position absolute
    top 4px
    left 42px
    right 0
    display flex
    flex-wrap nowrap
    justify-content flex-start
    align-items flex-start
    height 1446px
    &-cols
      position relative
      padding 0 6px
      // width 90px
      flex 1
      height 100%
      z-index 2
      border-left 1px solid #F1F2F3
      box-sizing border-box
      &:first-child
        border-left 0
</style>
